import { supabase } from "../config/supabase";




export interface Doctor {
  doctorId: string;
  userId: string;
  doctorCrefito: string;
  doctorCrm: string;
  doctorSpecialties?: string[]; // Tornar opcional se nem sempre presente
  doctorBiography?: string; // Tornar opcional se nem sempre presente
  doctorCreatedAt: string;
  doctorUpdatedAt: string;
}

export class DoctorService {
  static async getDoctorByuserId(userId: string): Promise<Doctor | null> {
    const { data, error } = await supabase
      .from("doctors")
      .select("*")
      .eq("userId", userId)
      .maybeSingle();

    if (error) {
      console.error("Error fetching doctor:", error);
      throw error;
    }

    return data as Doctor | null;
  }

  static async createDoctor(doctorData: Partial<Doctor>): Promise<Doctor | null> {
    const now = new Date().toISOString();
    // Remover clientId do doctorData, pois a tabela 'doctors' não contém clientId.
    // As informações de clientId para profissionais são gerenciadas na tabela 'user_clients'.
    delete (doctorData as any).clientId;
    const { data, error } = await supabase
      .from("doctors")
      .insert([{ ...doctorData, doctorCreatedAt: now, doctorUpdatedAt: now }])
      .select()
      .single();
    if (error) {
      console.error("Error creating doctor:", error);
      throw error;
    }
    return data as Doctor | null;
  }

  static async updateDoctor(doctorId: string, updates: Partial<Doctor>): Promise<Doctor | null> {
    // Filtra propriedades legadas que não pertencem à identidade profissional.
    const doctorUpdatesForSupabase = { ...updates };
    delete (doctorUpdatesForSupabase as any).doctorIsActive;
    delete (doctorUpdatesForSupabase as any).pricePerSession;
    delete (doctorUpdatesForSupabase as any).clientId; // Garantir que clientId não seja passado para a tabela doctors

    // Em seguida, tipamos corretamente para o resto do fluxo
    const finalDoctorUpdates: Partial<Doctor> = doctorUpdatesForSupabase;

    console.log("Updating doctor with:", finalDoctorUpdates);
    const { data, error } = await supabase
      .from("doctors")
      .update({ ...finalDoctorUpdates, doctorUpdatedAt: new Date().toISOString() })
      .eq("doctorId", doctorId)
      .select()
      .single();

    if (error) {
      console.error("Error updating doctor:", error);
      throw error;
    }

    return data as Doctor | null;
  }
}
